import { SortDir } from '@shared';

export interface SortByParam {
  sortBy: string;
  label: string;
  direction?: SortDir;
  type?: any;
}

export interface SortByParamConfig {
  mlScore: SortByParam;
  mostRecentApplication: SortByParam;
  latestApplicationDate: SortByParam;
  oldestApplicationDate: SortByParam;
  rejectionDate: SortByParam;
  submittedToHMDate: SortByParam;
  advancedByHMDate: SortByParam;
  applicationDate: SortByParam;
}

export const sortByParamConfig: SortByParamConfig = {
  mlScore: { sortBy: 'MATCHING_QUALITY', label: 'Matching quality' },
  mostRecentApplication: { sortBy: 'MOST_RECENT', label: 'Most recent' },
  latestApplicationDate: {
    sortBy: 'MOST_RECENT',
    label: 'Recent application date',
    direction: SortDir.DESC,
  },
  oldestApplicationDate: {
    sortBy: 'OLDEST_APPLICATION',
    label: 'Oldest application date',
    direction: SortDir.ASC,
  },
  rejectionDate: { sortBy: 'LATEST_REJECTED', label: 'Recent rejection date', type: 'Rejected' },
  submittedToHMDate: { sortBy: 'SUBMITTED_TO_HM', label: 'Submission date', type: 'Submitted' },
  advancedByHMDate: { sortBy: 'ADVANCED_BY_HM', label: 'Advancement date', type: 'Advanced' },
  applicationDate: { sortBy: 'MOST_RECENT', label: 'Application date', type: 'Recent' },
};
